import { FETCH_ARTISTS_SEARCH_RESULTS } from "../../../../../graphql/query/Artist";
import { artistFilterStore } from "../../../components/useArtistFilters";

const SearchedArtists = props => {
  const tableProps = {
    dataKey: "artistsV2",
    FETCH_QUERY: FETCH_ARTISTS_SEARCH_RESULTS,
    variables: {
      ...artistFilterStore.get(),
    },
  };

  return tableProps;
};

export default SearchedArtists;
